(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allergy-hub-glossary"]) return;
  try {
    
// Keep one group open and center the opened heading in the viewport.
  document.querySelectorAll('.allergy-hub-glossary').forEach((glossary) => {
    const groups = [...glossary.querySelectorAll('.allergy-hub-glossary__group')];

    groups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;

        const summary = group.querySelector('.allergy-hub-glossary__summary');

        // Close other groups before centering the newly opened heading.
        groups.forEach((other) => other !== group && (other.open = false));

        // Center the opened heading in the viewport.
        if (summary) window.requestAnimationFrame(() => {
          window.scrollBy({
            top: summary.getBoundingClientRect().top - (window.innerHeight / 4),
            behavior: 'auto',
          });
        });
      });
    });

    groups.filter((group) => group.open).slice(1).forEach((group) => (group.open = false));
  });

  document.addEventListener('shopify:block:select', (event) => {
    const group = event.target.closest('.allergy-hub-glossary__group');
    if (group) group.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
